// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { MainWindowManager } from "../../UtilsClasses/MainWindowManager.js";
import { Resources } from "../../../Commons/properties/Resources.js";
import { QuickTreeNode } from "../QuickTree/QuickTreeNode.js";
import { TerceraQuickTree } from "../QuickTree/TerceraQuickTree.js";
import { TerceraButton } from "../TerceraButton.js";
import { TerceraLabel } from "../TerceraLabel.js";
import { TerceraTextBox } from "../TerceraTextBox.js";
import { TerceraLookupDropDownForm } from "./TerceraLookupDropDownForm.js";
import { IndicatorManager } from "../../../Commons/cache/indicators/IndicatorManager.js";
export let TerceraIndicatorLookupDropDownForm = TerceraLookupDropDownForm.extend({});

let instance = null;

TerceraIndicatorLookupDropDownForm.prototype.getType = function () { return 'TerceraIndicatorLookupDropDownForm' };

TerceraIndicatorLookupDropDownForm.prototype.fillTree = function ()
{
    var startNode = new QuickTreeNode();;

    var filter = this.currentNameFilter;
    var procs = this.items;

    if (filter)
        filter.toLowerCase();

    var visibleIndicatorCount = 0;

    var len = procs.length;
    let map = {};
    for (var i = 0; i < len; i++)
    {
        var handler = procs[i];

        if (filter)
            if (handler.ShortName.toLowerCase().indexOf(filter) === -1 && handler.FullName.toLowerCase().indexOf(filter) === -1)
                continue;

        visibleIndicatorCount++;

        let parentNode = map[handler.DisplayGroup];
        if (!parentNode)
        {
            parentNode = new QuickTreeNode();
            parentNode.nodeText = Resources.getResource("IndicatorGroup." + handler.DisplayGroup);
            parentNode.tag = null;
            parentNode.collapsed = false;
            map[handler.DisplayGroup] = parentNode;

            startNode.AddChildNode(parentNode);
        }

        var subNode = new QuickTreeNode();
        subNode.nodeText = Resources.getResource(handler.ShortName) + " (" + Resources.getResource(handler.FullName) + ")";
        subNode.tag = handler;

        parentNode.AddChildNode(subNode);
    }

    var qt = this.quickTree.quickTree;

    qt.Clear();
    qt.AddNodeRange(startNode.childNodes);

    this.updateVisibleIndicatorsCount(visibleIndicatorCount);
};

TerceraIndicatorLookupDropDownForm.prototype.updateVisibleIndicatorsCount = function (visibleIndicatorsCount)
{
    this.labelCount.set('text', visibleIndicatorsCount ?
        Resources.getResource('screen.lookup.scripts.showing').replace('{1}', visibleIndicatorsCount) :
        Resources.getResource('screen.lookup.scripts.noitems'));
};

TerceraIndicatorLookupDropDownForm.prototype.createFooterBtns = function ()
{
    var addBtn = new TerceraButton();
    var cancelBtn = new TerceraButton();

    addBtn.set({
        left: 200,
        top: 442,
        terceraButtonStyle: TerceraButton.TerceraButtonStyle.Standard
    });
    addBtn.onClick.Subscribe(function ()
    {
        if (this.callBack)
        {
            var selectedNode = this.quickTree.quickTree.selectedNode;
            if (selectedNode) this.callBack(selectedNode.tag);
            this.close();
        }
    }.bind(this));
    this.addBtn = addBtn;
    this.addControl(addBtn);

    cancelBtn.set({
        left: 306,
        top: 442,
        width: 92,
        terceraButtonStyle: TerceraButton.TerceraButtonStyle.Standard,
        text: Resources.getResource('panel.TerceraSymbolLookupDropDownForm.Cancel')
    });
    cancelBtn.onClick.Subscribe(function () { this.close(); }.bind(this));
    this.addControl(cancelBtn);
};

TerceraIndicatorLookupDropDownForm.PopulateWithFolderNodes = function (handler, curNode)
{
    let folderNode = new QuickTreeNode();
    folderNode.nodeText = handler.DisplayGroup;
    folderNode.tag = true;
    curNode.AddChildNode(folderNode);
    return folderNode;
};

TerceraIndicatorLookupDropDownForm.ShowForm = function (params)
{
    var lookup = TerceraIndicatorLookupDropDownForm.getInstance();
    lookup.textBox.set('text', '');
    params.items = IndicatorManager.GetIndicatorItemsList();
    params.isMultiSelect = false;
    params.isCentered = true;
    lookup.showForm(params);
};

TerceraIndicatorLookupDropDownForm.getInstance = function ()
{
    if (instance)
        return instance;

    var leftOffset = 5;
    var topOffset = 5;

    var textBoxWidth = 400;
    var textBoxHeigth = 20;

    var quickTreeWidth = 400;
    var quickTreeHeigth = 370;
    var quickTopOffset = topOffset * 2 + textBoxHeigth;

    var lookup = new TerceraIndicatorLookupDropDownForm();
    lookup.set('visible', false);
    lookup.set('showFooter', true);
    lookup.setBounds(0, 0, 410, 485);
    MainWindowManager.MainWindow.addControl(lookup);

    var lookupAccountTB = new TerceraTextBox();
    lookupAccountTB.setBounds(leftOffset, topOffset, textBoxWidth, textBoxHeigth);
    lookup.addControl(lookupAccountTB);
    lookup.textBox = lookupAccountTB;

    var quickTree = new TerceraQuickTree();
    quickTree.setBounds(leftOffset, quickTopOffset, quickTreeWidth, quickTreeHeigth);
    quickTree.set('boldRootNode', true);
    lookup.addControl(quickTree);
    lookup.quickTree = quickTree;

    var labelCount = new TerceraLabel();
    labelCount.setBounds(9, 413, 400, 25);
    lookup.addControl(labelCount);
    lookup.labelCount = labelCount;

    instance = lookup;
    return lookup;
};